<template>
<div class="chapter">
<div class="inner_page">
<div class="calibre1">
<p class="content-chapter" id="toc_marker-2"> </p>
<p class="Text-body-centered">DEDICATION</p>
<p class="Text-body-centered1"> </p>
<p class="Text-body-centered1">To Connor</p>
<p class="Text-body-centered2">May you always know what to fight for.</p>
<p class="Text-body-centered">***</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// highway-2.vue?8fc37adc